export default __webpack_public_path__ + "static/media/cross-white.24c08fb2.svg";